import { useCallback, useRef } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useDebouncedCallback = <Params extends any[]>(
  callback: (...params: Params) => unknown,
  { runWhenTriggered, timeout } = { runWhenTriggered: false, timeout: 200 },
) => {
  const timeoutRef = useRef<number>(-1);

  return useCallback(
    (...params: Params) => {
      if (runWhenTriggered) callback(...params);

      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(
        () => callback(...params),
        timeout,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ) as any;
    },
    [callback, runWhenTriggered, timeout],
  );
};
